import { useCraftProp } from '../../utils'
import ColorPreview from '../Color/ColorPreview'

const BackgroundColorPreview = ({ name }) => {
  const { value, setValue } = useCraftProp(name)
  return <>
    <ColorPreview
      variant='accent'
      value={value}
      onChange={setValue}
      components={['preview', 'input']}
    />
  </>
}

export { BackgroundColorPreview }
